module.exports = __webpack_public_path__ + "static/media/project-empty.0d807a8b.png";